import angular from 'angular'
import './step1/step1.controller'
import './step2/step2.controller'
import './step2/step2.react'
import './step3/step3.controller'
import './step3/step3.react'
import './step4/step4.controller'
import './step4/step4.react'
import './step5/step5.controller'
import './step5/step5.react'
import './step6/step6.controller'
import './from_this_channel/from_this_channel'
import './from_this_channel/from_this_channel.react'
import './bundles.service'
import './odds.service'
import './bundles.scss'

angular
  .module('pub.bundle', [
    'pub.bundle.step1',
    'pub.bundle.step2',
    'pub.bundle.step3',
    'pub.bundle.step4',
    'pub.bundle.step5',
    'pub.bundle.step6',
    'pub.bundle.from_this_channel',
    'pub.bundle.service',
    'pub.odds.service',
  ])
  .controller('BundlesCtrl', BundlesCtrl)

/** @ngInject */
function BundlesCtrl(
  $scope,
  $state,
  $stateParams,
  $timeout,
  $q,
  $rootScope,
  $filter,
  ChannelsService,
  SetsService,
  BundleService,
  UploadService,
) {
  var vm = this
  vm.model = {}
  vm.items = []
  vm.lastIndex = 0
  vm.sortType = 'n'
  vm.sortReverse = false

  vm.channelId = $stateParams.channelId

  vm.status = [
    {
      id: 0,
      name: 'Draft',
    },
    {
      id: 1,
      name: 'Published',
    },
    {
      id: 2,
      name: 'Sold Out',
    },
    {
      id: 4,
      name: 'Archived',
    },
    {
      id: 7,
      name: 'Unavailable',
    },
    {
      id: 10,
      name: 'Awaiting Collectible Count',
    },
  ]

  load()

  ChannelsService.get().then(function (result) {
    vm.channels = result.results
  })

  if (!$stateParams.channelId) {
    SetsService.getId($stateParams.parentId).then(function (result) {
      var items = result.results
      vm.set = items
      if (vm.set['k-prod'] === 3) {
        $('.breadprogress-pagination p')[1].textContent = 'Figure'
      } else if (vm.set['k-prod'] === 2) {
        $('.breadprogress-pagination p')[1].textContent = 'Card'
      } else if (vm.set['k-prod'] === 1) {
        $('.breadprogress-pagination p')[1].textContent = 'Sticker'
      }
      $('#breadcrumb a').last().after(vm.set.t)
    })
  }

  $('#setSelect').select2('data', [])

  function load() {
    var groupItems = [
      {
        name: 'Published',
        children: [],
        colapse: true,
      },
      {
        name: 'Draft',
        children: [],
        colapse: true,
      },
      {
        name: 'Sold Out',
        children: [],
        colapse: false,
      },
      {
        name: 'Archived',
        children: [],
        colapse: false,
      },
      {
        name: 'Unavailable',
        children: [],
        colapse: false,
      },
      {
        name: 'Awaiting Collectible Count',
        children: [],
        colapse: false,
      },
    ]

    if (!$stateParams.channelId) {
      BundleService.getSetId($stateParams.parentId).then(callback)
    } else {
      BundleService.getChannelId($stateParams.channelId).then(callback)
    }

    function callback(result) {
      var results = result.results
      results = _.orderBy(results, ['ts-p'], ['desc'])
      for (var i = 0; i < results.length; i++) {
        if (result.results[i]['ts-p'] !== undefined && result.results[i]['ts-p'] !== null) {
          result.results[i]['ts-p1'] = result.results[i]['ts-p']
          result.results[i]['ts-p'] = new Date(
            parseInt(
              result.results[i]['ts-p']
                .toString()
                .substring(0, result.results[i]['ts-p'].toString().length - 3),
            ),
          )
        }
        if (result.results[i].ts) {
          result.results[i].ts = new Date(
            parseInt(
              result.results[i].ts
                .toString()
                .substring(0, result.results[i].ts.toString().length - 3),
            ),
          )
        }

        switch (results[i].st) {
          case 0:
            groupItems[1].children.push(results[i])
            break
          case 1:
            groupItems[0].children.push(results[i])
            break
          case 2:
            groupItems[2].children.push(results[i])
            break
          case 4:
            groupItems[3].children.push(results[i])
            break
          case 7:
            groupItems[4].children.push(results[i])
            break
          case 10:
            groupItems[5].children.push(results[i])
            break
          default:
            break
        }
      }

      vm.items = groupItems
    }
  }

  vm.dataCollapse = function (index) {
    if (vm.items[index].colapse) {
      vm.items[index].colapse = false
      return
    }
    vm.lastIndex = index
    vm.items[index].colapse = !vm.items[index].colapse
  }

  vm.create = function () {
    $state.go('pub.bundles.create', {
      parentId: $stateParams.parentId,
      channelId: $stateParams.channelId,
    })
  }

  vm.delete = function (id) {
    swal(
      {
        title: 'Delete',
        text: 'You want to delete this bundle ?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          BundleService.remove(id).then(function () {
            load()
          })
        }
      },
    )
  }

  vm.next = function () {
    $state.go('pub.reviews', { parentId: $stateParams.parentId })
  }

  vm.classDisabled = function () {
    if (vm.title === '' || vm.title === null || vm.title === undefined) {
      return 'is-disabled'
    } else {
      return
    }
  }

  vm.saveBundle = function () {
    $('#myModal').modal('hide')
    $('#myModal').on('hidden.bs.modal', function () {
      if (vm.channelId) {
        BundleService.saveChannel(vm.channelId, { t: vm.title }).then(function (result) {
          $timeout(function () {
            $state.go('pub.bundles.step1', {
              parentId: $stateParams.parentId,
              channelId: vm.channelId,
              id: result.results.id,
            })
          }, 250)
        })
      } else {
        BundleService.save($stateParams.parentId, { t: vm.title }).then(function (result) {
          $timeout(function () {
            $state.go('pub.bundles.step1', {
              parentId: $stateParams.parentId,
              channelId: $stateParams.channelId,
              id: result.results.id,
            })
          }, 250)
        })
      }
    })
  }

  vm.changeStatus = function (item, oldValue) {
    var old = parseInt(oldValue)
    vm.old = old
    var nameStatus = _.filter(vm.status, { id: item.st })[0].name
    swal(
      {
        title: 'Status',
        text: 'Are you sure you want to change this status to ' + nameStatus + ' ?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          $timeout(function () {
            if (item.st === 0) {
              vm.draft(item)
            } else if (item.st === 1) {
              vm.publish(true, item)
            } else if (item.st === 2) {
              vm.soldout(item)
            } else if (item.st === 4) {
              vm.archived(item)
            } else if (item.st === 7) {
              vm.unavailable(item)
            } else if (item.st === 10) {
              vm.awaiting(item)
            }
          }, 300)
        } else {
          item.st = old
          $scope.$apply()
        }
      },
    )
  }

  vm.awaiting = function (item) {
    BundleService.update($stateParams.parentId, item.id, { st: 10 }).then(function () {
      item.st = 4
      toastr.success('Awaiting Collectible Count')
      load()
    })
  }

  vm.archived = function (item) {
    BundleService.update($stateParams.parentId, item.id, { st: 4 }).then(function () {
      item.st = 4
      toastr.success('Archived')
      load()
    })
  }

  vm.unavailable = function (item) {
    BundleService.update($stateParams.parentId, item.id, { st: 7 }).then(function () {
      item.st = 7
      toastr.success('Unavailable')
      load()
    })
  }

  vm.draft = function (item) {
    BundleService.unpublish(item.id).then(
      function () {
        item.st = 0
        toastr.success('Draft')
        load()
      },
      function (err) {
        var e = err.error.message.split(';')
        var html = ''
        for (var i = 0; i < e.length; i++) {
          html += '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
        }
        $timeout(function () {
          swal({
            title: 'Pack Incomplete',
            text: html,
            html: true,
          })
          item.st = vm.old
        }, 500)
      },
    )
  }

  vm.publish = function (state, item) {
    var msg = ''
    if (state) {
      msg = 'Yes, publish it'
    } else {
      msg = 'Yes, unpublish it?'
    }

    swal(
      {
        title: 'Are you sure?',
        showCancelButton: true,
        confirmButtonText: msg,
        closeOnConfirm: true,
        type: 'warning',
        animation: 'slide-from-top',
        allowEscapeKey: false,
        allowOutsideClick: false,
      },
      function (isConfirm) {
        if (!isConfirm) {
          load()
          return
        } else {
          if (state) {
            BundleService.publish(item.id).then(
              function () {
                item.st = 1
                toastr.success('Published')
                load()
              },
              function (err) {
                var e = err.error.message.split(';')
                var html = ''
                for (var i = 0; i < e.length; i++) {
                  html += '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
                }

                $timeout(function () {
                  swal({
                    title: 'Pack Incomplete',
                    text: html,
                    html: true,
                  })
                  item.st = vm.old
                }, 500)
              },
            )
          } else {
            if (item.st === 2) {
              swal("You can't unpublish a bundle that is sold out.")
              return
            }

            BundleService.unpublish(item.id).then(
              function () {
                item.st = 0
                toastr.success('Unpublish')
                load()
              },
              function (err) {
                var e = err.error.message.split(';')
                var html = ''
                for (var i = 0; i < e.length; i++) {
                  html += '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
                }
                $timeout(function () {
                  swal({
                    title: 'Pack Incomplete',
                    text: html,
                    html: true,
                  })
                  item.st = vm.old
                }, 500)
              },
            )
          }
        }
      },
    )
  }

  vm.soldout = function (item) {
    BundleService.update($stateParams.parentId, item.id, { st: 2 }).then(function () {
      item.st = 2
      toastr.success('Sold Out')
      load()
    })
  }

  vm.cloneOn = false
  vm.cloneModel = {
    option: 'current',
    isChannelLevel: false,
    channelId: null,
    setId: null,
    bundle: null,
    order: 0,
  }
  vm.clone = function (item) {
    vm.cloneModel = {
      option: 'current',
      channelId: null,
      setId: null,
      isChannelLevel: false,
      bundle: angular.copy(item),
      order: item.n,
    }
    $('#modalClone').modal('show')
  }

  vm.cloneBundleAnotherSet = function () {
    if (
      !$('#setSelect').select2('val') &&
      !vm.cloneModel.isChannelLevel &&
      vm.cloneModel.option !== 'current'
    ) {
      swal('Set is required', '', 'error')
      return
    }
    if (
      vm.cloneModel.isChannelLevel &&
      !vm.cloneModel.channelId &&
      vm.cloneModel.option !== 'current'
    ) {
      swal('Channel is required', '', 'error')
      return
    }

    vm.cloneOn = true

    if (vm.cloneModel.option !== 'current') {
      if (vm.cloneModel.isChannelLevel) {
        vm.cloneModel.bundle['id-ch'] = parseInt(vm.cloneModel.channelId)
      } else {
        vm.cloneModel.bundle['id-s'] = parseInt($('#setSelect').select2('val'))
      }
    } else {
      if ($stateParams.channelId) {
        vm.cloneModel.bundle['id-ch'] = parseInt(vm.channelId)
      } else {
        vm.cloneModel.bundle['id-s'] = parseInt($stateParams.parentId)
      }
    }
    BundleService.clone(vm.cloneModel.bundle.id, vm.cloneModel.bundle).then(function (res) {
      var updateBundle = {
        n: parseInt(vm.cloneModel.order),
        'ts-p': vm.cloneModel.bundle['ts-p1'],
        'ts-f': vm.cloneModel.bundle['ts-f'],
      }

      if (vm.cloneModel.option !== 'current') {
        if (vm.cloneModel.isChannelLevel) {
          updateBundle['id-ch'] = vm.cloneModel.bundle['id-ch']
          updateBundle['id-s'] = null
        } else {
          updateBundle['id-ch'] = null
          updateBundle['id-s'] = vm.cloneModel.bundle['id-s']
        }
      } else {
        if ($stateParams.channelId) {
          updateBundle['id-ch'] = vm.cloneModel.bundle['id-ch']
          updateBundle['id-s'] = null
        } else {
          updateBundle['id-ch'] = null
          updateBundle['id-s'] = vm.cloneModel.bundle['id-s']
        }
      }

      BundleService.update(0, res.results.id, updateBundle).then(function () {
        swal('Cloned!', 'success')
        load()
        $('#modalClone').modal('hide')
        vm.cloneOn = false
        vm.cloneModel = {
          option: 'current',
          isChannelLevel: false,
          channelId: null,
          setId: null,
          bundle: null,
          order: 0,
        }
      })
    })
  }

  vm.prime = function (item) {
    swal(
      {
        title: 'Are you sure?',
        showCancelButton: true,
        confirmButtonText: 'Yes, prime it!',
        closeOnConfirm: false,
        type: 'warning',
        animation: 'slide-from-top',
        allowEscapeKey: false,
        allowOutsideClick: false,
      },
      function (isConfirm) {
        if (!isConfirm) {
          return
        } else {
          BundleService.prime(item.id).then(function () {
            swal('Prime Done!', 'success')
            load()
          })
        }
      },
    )
  }

  vm.deleteBundle = function (item) {
    swal(
      {
        title: 'Are you sure?',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        closeOnConfirm: false,
        type: 'warning',
        animation: 'slide-from-top',
        allowEscapeKey: false,
        allowOutsideClick: false,
      },
      function (isConfirm) {
        if (!isConfirm) {
          return
        }

        BundleService.remove(item.id).then(function () {
          swal('Deleted!', 'success')
          load()
        })
      },
    )
  }

  $('#myModal').on('shown.bs.modal', function () {
    $('#setPack').focus()
  })

  vm.changeOrder = function (item, currentList) {
    vm.order = null
    vm.currentItem = item
    vm.currentList = currentList || []
    $('#myModalOrder').modal('show')
  }

  $('#myModalOrder').on('shown.bs.modal', function () {
    $('#orderField').focus()
  })

  vm.saveOrder = function () {
    if (!vm.order) {
      $timeout(function () {
        swal('Field required', '', 'error')
      }, 300)
      return
    }

    BundleService.reorder($stateParams.parentId, vm.currentItem.id, parseInt(vm.order)).then(
      function () {
        $('#myModalOrder').modal('hide')
        load()
      },
      function (err) {
        $timeout(function () {
          swal(err.error.message, '', 'error')
        }, 300)
      },
    )
  }

  vm.sort = function (propertyName, data) {
    vm.sortReverse = !vm.sortReverse
    vm.sortType = propertyName
    for (var i = 0; i < vm.items.length; i++) {
      if (vm.items[i].name === data.name) {
        vm.items[i].children = $filter('orderBy')(vm.items[i].children, vm.sortType, vm.sortReverse)
        break
      }
    }
  }

  vm.goStep1 = function (item) {
    $state.go('pub.bundles.step1', {
      id: item.id,
      parentId: $stateParams.parentId || 0,
      channelId: $stateParams.channelId,
    })
  }

  vm.seeAllBundles = function () {
    $state.go('pub.bundles', {
      parentId: $stateParams.parentId,
      channelId: vm.set['id-ch'],
    })
  }

  vm.bundlesTranslations = []
  vm.translate = {}
  vm.pathImgTTranslation = ''
  vm.pathImgLTranslation = ''
  vm.pathImgTMTranslation = ''
  vm.loadTTranslation = false
  vm.loadLTranslation = false
  vm.loadTMTranslation = false
  vm.translations = function (item) {
    vm.itemSelected = item
    loadTranslations()
    $('#modalTranslate').modal('show')
  }

  vm.translate = {}
  vm.addTranslate = function () {
    vm.translate = {}
    $('#modalTranslateAdd').modal('show')
  }

  function loadTranslations() {
    BundleService.listTranslations(vm.itemSelected.id).then(function (result) {
      vm.bundlesTranslations = result.results
    })
  }

  vm.classDisabled = function () {
    if (!vm.translate.comm || !vm.translate.t) {
      return 'is-disabled'
    } else {
      return
    }
  }

  vm.saveTranslate = function () {
    if (vm.translate.id) {
      vm.translate['id-b'] = vm.itemSelected.id
      BundleService.updateTranslation(vm.translate.id, vm.translate).then(
        function () {
          loadTranslations()
          vm.translate = {}
          $('#modalTranslateAdd').modal('hide')
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
    } else {
      vm.translate['id-b'] = vm.itemSelected.id
      BundleService.createTranslation(vm.itemSelected.id, vm.translate).then(
        function () {
          loadTranslations()
          vm.translate = {}
          $('#modalTranslateAdd').modal('hide')
        },
        function (err) {
          swal(err.error.message, '', 'error')
        },
      )
    }
  }

  vm.editTranslate = function (id) {
    BundleService.getTranslation(id).then(
      function (result) {
        vm.translate = result.results
        $('#modalTranslateAdd').modal('show')
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.deleteTranslate = function (id) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          BundleService.removeTranslation(id).then(
            function () {
              loadTranslations()
              vm.translate = {}
              $('#modalTranslateAdd').modal('hide')
            },
            function (err) {
              $timeout(function () {
                swal(err.error.message, '', 'error')
              }, 500)
            },
          )
        } else {
          return
        }
      },
    )
  }

  vm.uploadTTranslation = function (item) {
    vm.loadTTranslation = true
    UploadService.save('bundles', vm.pathImgTTranslation, 'img-t', item.id).then(
      function (fileName) {
        vm.loadTTranslation = false
        item['img-t'] = fileName
      },
    )
  }

  vm.uploadLTranslation = function (item) {
    vm.loadLTranslation = true
    UploadService.save('bundles', vm.pathImgLTranslation, 'img-l', item.id).then(
      function (fileName) {
        vm.loadLTranslation = false
        item['img-l'] = fileName
      },
    )
  }

  vm.uploadTMTranslation = function (item) {
    vm.loadTMTranslation = true
    UploadService.save('bundles', vm.pathImgTMTranslation, 'img-tm', item.id).then(
      function (fileName) {
        vm.loadTMTranslation = false
        item['img-tm'] = fileName
      },
    )
  }

  vm.moveTo = function () {
    $('#modalMoveTo').modal('show')
  }
}
